import api from "./api";
import API_ROUTES from "./apiRoutes";

export const getDashboardStats = async ({ societyId } = {}) => {
  const params = {};
  if (societyId) params.society_id = societyId;
  const res = await api.get(API_ROUTES.dashboard.stats, { params });
  return res.data;
};
